import React from 'react';
import './accounts.scss';
import AccountsMainNav from '../../components/mweb/Accounts/AccountMainNav';
import { connect } from 'react-redux';
import AccountMenu from '../../components/mweb/Accounts/AccountMenu';
import {
  getOrders,
  postReorder,
} from 'hb-redux-store/feature/accounts/accounts.action';
import AppBar from '../../components/mweb/AppBar/AppBar';
import Orders from './Orders';
import { postLogout } from '../../hb-redux-store/feature/login/login.action';
import { isLoggedInUser } from 'hb-redux-store/util/cookieService';
import { AppDownload } from 'components/mweb/AppDownload/AppDownload';
class AccountHome extends React.Component {
  componentDidMount() {
    isLoggedInUser() && this.props.getOrders();
  }

  render() {
    const loggedInUser = isLoggedInUser();
    const { launchInfo } = this.props;
    return (
      <div className="my-accounts">
        <AccountsMainNav />
        <AppDownload containerStyle="account-app-download-container" />
        <AccountMenu
          onLogout={this.props.postLogout}
          isReferralActive={this.props.launchInfo?.referralActive}
        />
        <div className="section-divider"></div>
        {loggedInUser && this.props.onGoingOrders?.orderSet?.length > 0 && (
          <React.Fragment>
            <Orders
              title="Ongoing Order"
              orders={this.props.onGoingOrders.orderSet}
            />
            <div className="section-divider"></div>
          </React.Fragment>
        )}
        {loggedInUser && this.props.pastOrders?.orderSet?.length > 0 && (
          <Orders
            title="Past Orders"
            orders={this.props.pastOrders.orderSet}
            pastOrders
            onReorder={orderNo => this.props.postReorder({ orderNo })}
          />
        )}
        <AppBar cartQty={this.props.cartQty} launchInfo={launchInfo} />
      </div>
    );
  }
}

const mapStateToProps = ({ initialReducer, accountsReducer, cartReducer }) => ({
  launchInfo: initialReducer.launchInfo,
  onGoingOrders: accountsReducer.onGoingOrders,
  pastOrders: accountsReducer.pastOrders,
  cartQty: cartReducer.cartQtyCount,
});

const mapDispatchToProps = {
  getOrders,
  postLogout,
  postReorder,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountHome);
